export default __webpack_public_path__ + "static/thinFont-7e322e054ca2e69d86348be7e9ae0e07.woff";